import { render } from "./ClientListView.vue?vue&type=template&id=18eaef7a&scoped=true"
import script from "./ClientListView.vue?vue&type=script&lang=js"
export * from "./ClientListView.vue?vue&type=script&lang=js"

import "./ClientListView.vue?vue&type=style&index=0&id=18eaef7a&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18eaef7a"]])

export default __exports__